import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPanoramaView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPanoramaView"><Path d="M22.25 16.1067V7.87227C22.25 5.82174 20.2352 4.38148 18.2297 4.80868C14.0216 5.70506 9.9784 5.70506 5.77031 4.80868C3.76478 4.38148 1.75 5.82175 1.75 7.87227V16.1067C1.75 18.1633 3.77646 19.605 5.78737 19.1739C9.97453 18.2762 14.0255 18.2762 18.2126 19.1739C20.2235 19.605 22.25 18.1633 22.25 16.1067Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPanoramaView;
